import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Box, Typography, Stack, Tooltip, IconButton } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import DataGridTable from '../../Components/DataGrid';
import BiztantuLoader from '../../Components/Loader';
import { requestGetWorkflowLogs, requestGetWorkflowLogDetail } from '../../Store/Workflows/action';
import StepDetailDialog from './StepDetailDialog';
import { handleValidateCodevalue, dateTimeISTFormatter } from '../../Utility/constant';
import SelectBoxWithLabel from '../../Components/SelectBoxWithLable';
import {
    StyledConfigurationContainer,
    StyledIndexContainerDiv,
} from '../../Components/Styled';

import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import './workflow.css';

const WorkflowLogsTab = () => {
    const dispatch          = useDispatch();
    const internationalise  = useSelector(state => state?.internationalise?.currentHashMapData);
    const isLoadingProgress = useSelector(state => state.global.isLoading);
    const workflows         = useSelector(state => state?.workflows?.workflows || []);
    const logs              = useSelector(state => state?.workflows?.workflowLogs || []);
    const logDetail         = useSelector(state => state?.workflows?.workflowLogDetail);

    const [selectedWorkflowId, setSelectedWorkflowId] = useState('');
    const [detailOpen, setDetailOpen]                  = useState(false);

    const workflowOptions = useMemo(() => (workflows || []).map(wf => ({
        label: wf.name,
        value: wf.id,
    })), [workflows]);

    useEffect(() => {
        if (selectedWorkflowId) {
            dispatch(requestGetWorkflowLogs(selectedWorkflowId));
        }
    }, [dispatch, selectedWorkflowId]);

    const handleWorkflowChange = useCallback((e) => setSelectedWorkflowId(e.target.value), []);
    const handleViewDetail = useCallback(async (logId) => {
        await dispatch(requestGetWorkflowLogDetail(logId));
        setDetailOpen(true);
    }, [dispatch]);
    const handleCloseDetail = useCallback(() => setDetailOpen(false), []);

    const columns = useMemo(() => [
        {
            field: 'workflowRunId',
            headerName: 'WorkFlow Run ID',
            flex: 1,
            minWidth: 90,
            editable: false,
        },
        {
            field: 'workflowName',
            headerName:'Workflow Name',
            flex: 1,
            minWidth: 180,
            editable: false,
        },
        {
            field: 'status',
            headerName: 'Status',
            width: 180,
            editable: false,
            valueGetter: ({ value }) => value ? handleValidateCodevalue(internationalise, value) || value : '',
        },
        {
            field: 'startedAt',
            headerName:'Started At',
            width: 180,
            editable: false,
            valueFormatter: (params) => {
                if (!params?.value) return "";
                return dateTimeISTFormatter(params?.value);
            },
        },
        {
            field: 'endedAt',
            headerName: 'Ended At',
            width: 180,
            editable: false,
            valueFormatter: (params) => {
                if (!params?.value) return "";
                return dateTimeISTFormatter(params?.value);
            },
        },
        {
            field: 'viewDetail',
            headerName: 'View',
            minWidth: 150,
            sortable: false,
            editable: false,
            renderCell: ({ row }) => (
            <Tooltip title={"View log details"}>
                <IconButton
                    onClick={() => {handleViewDetail(row?.id)}}
                    >
                <RemoveRedEyeIcon/>
                </IconButton>
            </Tooltip>
            ),
        },
    ], [handleViewDetail, internationalise]);

   
    return (
        <BiztantuLoader isChildren={true} open={isLoadingProgress}>
            <Box className="workflow-index-container">

                <StyledConfigurationContainer>
                    <Typography variant="h6">
                        {handleValidateCodevalue(internationalise, 'WF_LOG_TITLE') || 'Execution Logs'}
                    </Typography>
                </StyledConfigurationContainer>

                <StyledIndexContainerDiv className="workflow-logs-panel">

                    <Stack
                        className="table-header-search table-header-search-common workflow-logs-toolbar workflow-logs-filter"
                    >
                        <SelectBoxWithLabel
                            name="selectedWorkflow"
                            value={selectedWorkflowId}
                            label='Select Workflow'
                            optionMenuItem={workflowOptions}
                            handleOnChange={handleWorkflowChange}
                        />
                    </Stack>

                    <DataGridTable
                        isCheckboxReq={false}
                        isRequiredToolBar={true}
                        height="calc(100vh - 300px)"
                        dataGridData={selectedWorkflowId ? logs : []}
                        columns={columns}
                        marginTop="0px"
                    />

                </StyledIndexContainerDiv>
            </Box>

            {/* Step detail dialog */}
            <StepDetailDialog
                open={detailOpen}
                onClose={handleCloseDetail}
                logDetail={logDetail}
            />
        </BiztantuLoader>
    );
};

export default WorkflowLogsTab;
